import { connect } from "react-redux"
import React, { Component } from "react"
import moment from "moment"

import type { LinkedNode, Role } from "../../../../types/types"
import { autocompleteTopicsAndDimensionsRequest } from "../../../../actions/autocomplete-actions"
import { getRoleOptions } from "../../../../config/util-functions"
import { roleAdd } from "../../../../actions/role-actions"
import SelectTags from "../../../common/tags/SelectTags"
import WidgetHeaderButton from "../../../common/WidgetHeaderButton"

type Props = {
    isMissingRole: boolean,
    stakeholderType: string,
    onTopicsAndDimensionsSearch: (string, Function) => void,
    onAddRole: Role => void
}

type State = {
    newRole: Role
}

export const setNewRoleDefault = (stakeholderType: string) => ({
    name: getRoleOptions(stakeholderType)[0],
    evidence: [],
    linked_node: undefined,
    id: moment().unix()
})

export class NewRoleBlock extends Component<Props, State> {
    state = {
        newRole: setNewRoleDefault(this.props.stakeholderType)
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (this.props.stakeholderType !== nextProps.stakeholderType) {
            this.setState({
                newRole: {
                    ...this.state.newRole,
                    name: getRoleOptions(nextProps.stakeholderType)[0]
                }
            })
        }
    }

    handleAddRole = () => {
        this.props.onAddRole(this.state.newRole)

        this.setState({
            newRole: setNewRoleDefault(this.props.stakeholderType)
        })
    }

    handleNewRoleChange = (linkedNode: LinkedNode) => {
        this.setState({
            newRole: {
                ...this.state.newRole,
                linked_node: linkedNode
            }
        })
    }

    setNewRoleName = (event: SyntheticEvent<HTMLButtonElement>) => {
        this.setState({
            newRole: {
                ...this.state.newRole,
                name: event.currentTarget.value
            }
        })
    }

    render() {
        const { newRole } = this.state

        const {
            stakeholderType,
            isMissingRole,
            onTopicsAndDimensionsSearch
        } = this.props

        const roleOptions = getRoleOptions(stakeholderType)

        return (
            <div className="stakeholder-role-edit-container">
                <div className="stakeholder-role-edit-block">
                    <select
                        name="newRole"
                        onChange={this.setNewRoleName}
                        className="form-control stakeholder-role-select"
                        value={newRole.name}
                        required
                        data-cy="stakeholderRoleSelect"
                    >
                        {roleOptions.map(role => (
                            <option value={role} key={role}>
                                {role}
                            </option>
                        ))}
                    </select>
                    <div className="stakeholder-role-tags-container">
                        <SelectTags
                            name="area"
                            className={
                                isMissingRole && !newRole.linked_node
                                    ? "select-tags--invalid"
                                    : ""
                            }
                            multi={false}
                            value={newRole.linked_node}
                            valueKey="name"
                            placeholder="Type to search"
                            onChange={this.handleNewRoleChange}
                            loadOptions={onTopicsAndDimensionsSearch}
                        />
                    </div>
                    <span style={{ width: "16px" }} />
                </div>

                <WidgetHeaderButton
                    additionalClasses="pull-right margin-bottom--20"
                    onClick={this.handleAddRole}
                    disabled={!newRole.linked_node}
                    data-cy="addStakeholderRelationshipButton"
                >
                    Add
                </WidgetHeaderButton>
            </div>
        )
    }
}

const mapStateToProps = ({ presentation }, props) => ({
    isMissingRole: presentation.stakeholders.isMissingRole
})

const mapDispatchToProps = dispatch => ({
    onAddRole: newRole => {
        dispatch(roleAdd(newRole))
    },
    onTopicsAndDimensionsSearch: (searchTerm, callback) => {
        dispatch(autocompleteTopicsAndDimensionsRequest(searchTerm, callback))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(NewRoleBlock)
